<svg
viewbox="0 0 448 96"
fill="currentColor"
xmlns="http://www.w3.org/2000/svg">
<path
    d="M416 0H32C14.33 0 0 14.33 0 32V64C0 81.67 14.33 96 32
    96H416C433.67 96 448 81.67 448 64V32C448 14.33 433.67 0 416 0Z" />
</svg>